const isPdfExtensions = (url) => {
    if (url) {
        return url.toLowerCase().endsWith('.pdf');
    }
};


export {
    isPdfExtensions
}